import React from 'react';
import {useTranslation} from "react-i18next";
import {generate} from "../../../routing/routes";
import {FormHeading} from "../../shared/components/Typograhy";
import {BackButton, ButtonArea, NextButton} from "../../shared/components/Buttons";
import {useDispatch} from "react-redux";
import {cancel} from "../../../data/booking/actions/booking";

const SaveDraftConfirmation = ({ data }) =>{
    const { t } = useTranslation();
    const dispatch = useDispatch();

    return <>
        <FormHeading title="Demande enregistrée !" />

        <p className="my-20">
            Votre projet de voyage a bien été enregistré, vous pourrez continuer l'édition ultérieurement.
        </p>
        <ButtonArea>
            <BackButton onClick={()=>{
                dispatch(cancel())}
            }>
                Revenir à l'édition
            </BackButton>
            <NextButton href={generate('account_dashboard')} classname="ml-auto">
                {t("account_button.dashboard")}
            </NextButton>
        </ButtonArea>
    </>}
;

export default SaveDraftConfirmation;
